__turbopack_context__.v({
  "ArticlesListGrid": "cOCcPq_ArticlesListGrid",
  "ArticlesListItems": "cOCcPq_ArticlesListItems",
  "ArticlesListPage": "cOCcPq_ArticlesListPage",
  "ArticlesListWrapper": "cOCcPq_ArticlesListWrapper",
  "BlueGreen": "cOCcPq_BlueGreen",
  "ButtonContainer": "cOCcPq_ButtonContainer",
  "ButtonText": "cOCcPq_ButtonText",
  "Container": "cOCcPq_Container",
  "Content": "cOCcPq_Content",
  "Double": "cOCcPq_Double",
  "EnoughItems": "cOCcPq_EnoughItems",
  "Image": "cOCcPq_Image",
  "ImageContainer": "cOCcPq_ImageContainer",
  "Item": "cOCcPq_Item",
  "ItemContainer": "cOCcPq_ItemContainer",
  "ItemText": "cOCcPq_ItemText",
  "ItemTitle": "cOCcPq_ItemTitle",
  "LinkWrapper": "cOCcPq_LinkWrapper",
  "NotEnoughItems": "cOCcPq_NotEnoughItems",
  "PinkBlue": "cOCcPq_PinkBlue",
  "PinkOrange": "cOCcPq_PinkOrange",
  "PinkPurple": "cOCcPq_PinkPurple",
  "Root": "cOCcPq_Root",
  "SameBackground": "cOCcPq_SameBackground",
  "Single": "cOCcPq_Single",
  "SingleTitle": "cOCcPq_SingleTitle",
  "SliderContainer": "cOCcPq_SliderContainer",
  "ThreeItems": "cOCcPq_ThreeItems",
  "Title": "cOCcPq_Title",
  "TitleBottom": "cOCcPq_TitleBottom",
  "TitleContainer": "cOCcPq_TitleContainer",
  "TitleDesktop": "cOCcPq_TitleDesktop",
  "TitleMobile": "cOCcPq_TitleMobile",
  "TitleTop": "cOCcPq_TitleTop",
  "TransparentBackground": "cOCcPq_TransparentBackground",
  "Triple": "cOCcPq_Triple",
  "Visible": "cOCcPq_Visible",
});
